module.exports = __webpack_public_path__ + "static/media/38b02c72-795a-436d-96b6-63bf366b0b4c.9305b65c.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/1274145/38b02c72-795a-436d-96b6-63bf366b0b4c.woff2
// module id = 1662
// module chunks = 2